import React from 'react';
import { withNamespaces } from 'react-i18next';

const BankAccountInformationView = () => {
  return <div>BankAccountInformationView</div>;
};

export default withNamespaces()(BankAccountInformationView);
